export default "__VITE_ASSET__eHs0SagsEeFjb_nlLLf$zw__"